import { render, staticRenderFns } from "./CompetenceCategoryPicker.vue?vue&type=template&id=3645b8d9&scoped=true"
import script from "./CompetenceCategoryPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetenceCategoryPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompetenceCategoryPicker.vue?vue&type=style&index=0&id=3645b8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645b8d9",
  null
  
)

export default component.exports